/*
 * @Author: wuqinfa
 * @Date: 2022-11-22 10:54:01
 * @LastEditors: wuqinfa
 * @Description: 
 */
import mxcFactory from './mxcFactory';

// const instance = mxcFactory();
// export default instance;

// 如果像上面那样写的话，一旦这个文件被加载了，就会马上创建一个实例，里面的 cache.get('am-token') 没法拿到最新的值
export default (url: string, reqParams: any, mxcMessage = true) => mxcFactory(mxcMessage)(url, reqParams);